import { render, staticRenderFns } from "./vault-data-component.vue?vue&type=template&id=51719f72"
import script from "./vault-data-component.vue?vue&type=script&lang=js"
export * from "./vault-data-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports